import axiosInstance from 'src/utils/axios';
import JM from 'jalali-moment';

export const networkPostUploadFile = async (data) => {
  const res = await axiosInstance.post(`File/Upload/${JM(new Date()).format('YYYYMM')}`, data);
  return res;
};


export const networkUploadMediaFile = async (data) => {
  const res = await axiosInstance.post(`File/VideoFile/${JM(new Date()).format('YYYYMM')}`, data);
  return res;
};